/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2024-11-19 16:52:34
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-11-22 15:34:43
 * @FilePath: \vue-hepha-order\src\views\kpiDailyReport\queryConfig\KpiDailyReportQuery.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const KpiDailyReportQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'', // 发票日期
            key:'create_timestamp',
            type:'date',
            showTime:false,
            allowClear:true,
            disabledDate:true,
            disabledDateType:'after',
            width:'330px',
        },
    ]
}



KpiDailyReportQuery.formField.forEach(item=>{
    KpiDailyReportQuery.formData[item.key] = ''
})

export {
    KpiDailyReportQuery
}